import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import autosuggestMatch from 'autosuggest-highlight/match';
import autosuggestParse from 'autosuggest-highlight/parse';

var getSuggestionMeta = function getSuggestionMeta(suggestion) {
  return " ".concat(['county', 'region', 'country'].map(function (key) {
    return suggestion[key];
  }).filter(function (text) {
    return text;
  }).join(' '));
};

export var renderSuggestion = function renderSuggestion(suggestion, _ref) {
  var query = _ref.query;

  var highlight = function highlight(suggestionText) {
    var matches = autosuggestMatch(suggestionText, query);
    var parts = autosuggestParse(suggestionText, matches);
    return parts.map(function (part, index) {
      var className = part.highlight ? 'tds-location-autosuggest__suggestion--highlight' : null;
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        React.createElement("span", {
          className: className,
          key: "".concat(part.text, "-").concat(index)
        }, part.text)
      );
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "tds-location-autosuggest__suggestion--content"
  }, highlight(suggestion.name), /*#__PURE__*/React.createElement("span", {
    className: "tds-location-autosuggest__suggestion--meta"
  }, getSuggestionMeta(suggestion)));
};
renderSuggestion.displayName = "renderSuggestion";
export var getLocationDetails = function getLocationDetails(location) {
  var _location = _slicedToArray(location, 1),
      results = _location[0];

  var addressDetails = results.address_components;

  if (!addressDetails) {
    return {};
  }

  var getName = function getName(type) {
    var _addressDetails$filte = addressDetails.filter(function (address) {
      return address.types.indexOf(type) > -1;
    }),
        _addressDetails$filte2 = _slicedToArray(_addressDetails$filte, 1),
        result = _addressDetails$filte2[0];

    return result ? result.short_name : '';
  };

  var street = getName('route');
  var country = getName('country');
  var label = [street, country].filter(function (text) {
    return text;
  }).join(', ');
  return {
    label: label.length > 24 ? "".concat(label.slice(0, 24), "\u2026") : label,
    postcode: getName('postal_code')
  };
};
export var loadMapsApi = function loadMapsApi(mapsApiKey) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(mapsApiKey, "&callback=mapsApiReady");
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
};
export var fetchLocation = function fetchLocation(coordinates) {
  return new Promise(function (resolve) {
    var geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({
      location: coordinates
    }, function (location, status) {
      if (status === 'OK' && location) {
        resolve(location);
      }
    });
  });
};